var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"stuff"}},[_c('evolucao-vendas')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }